import { createSelector } from 'reselect'
import { IStore } from '../../index'
import { ILimits } from '../index'

export function getLimits(state: IStore): ILimits {
  return state.userAccount.limits
}

export const getLimitsBorder = createSelector(
  [getLimits],
  limit => ({
    add: limit.addLimit,
    copy: limit.copyLimit,
    edit: limit.editLimit,
    transfer: limit.transferLimit,
  }),
)

export function getLimitsTimeToReset(state: IStore) {
  return state.userAccount.limits.resetDate
}

export const getLimitsSorted = createSelector(
  [getLimits],
  limits => {
    return [
      {
        exceeded: limits.add >= limits.addLimit,
        limit: limits.addLimit,
        state: limits.add,
        type: 'z677_adding_reservations',
      },
      {
        exceeded: limits.edit >= limits.editLimit,
        limit: limits.editLimit,
        state: limits.edit,
        type: 'info_premium_edit_reservations',
      },
      {
        exceeded: limits.copy >= limits.copyLimit,
        limit: limits.copyLimit,
        state: limits.copy,
        type: 'z677_copying_reservations',
      },
      {
        exceeded: limits.transfer >= limits.transferLimit,
        limit: limits.transferLimit,
        state: limits.transfer,
        type: 'z677_moving_reservations',
      },
    ].sort((x, y) => (x.exceeded === y.exceeded ? 0 : x.exceeded ? -1 : 1))
  },
)
